import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import Toast from '../../services/toast.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'modal-update-worker-insurance',
	templateUrl: './modal-update-worker-insurance.component.html',
	imports: [
		CommonModule, MatSelectModule, TranslatePipe, LoaderOverlayComponent, 
		InputDatepickerNewComponent, ItemNotificationComponent, FormsModule
	]
})
export class ModalUpdateWorkerInsuranceComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private toast: Toast = inject(Toast);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalUpdateWorkerInsuranceComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getName = this.getName;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']);
		
		this.vm.uid = 'tw-' + Date.now();
		this.vm.businessUserWorker = this.vm.businessUserWorker;
		this.vm.user = this.session.getSession().user;
		this.vm.isInsuranceDatePickerHidden = this.session.isInsuranceDatePickerHidden();
		this.vm.extraData = {};
		this.vm.extraData.invitation = {};
		this.vm.extraData.invitation.id = this.vm.businessUserWorker.id;
		if (this.vm.user.service.insuranceChangesInFuture) {
			var today: any = new Date();
			var minDate: any = new Date();
			minDate.setDate(today.getDate() + this.config.getOtherConfig().INSURANCE_CHANGE_DELAY_IN_DAYS);
			this.vm.minDate = minDate;
		} else {
			this.vm.minDate = new Date(2020, 0, 1);
		}
		this.vm.getExistingInsurancePolicies = this.getExistingInsurancePolicies;
		this.vm.activePolicies = this.filterOutActivePolicies(
			this.vm.user.activeInsurancePolicies, 
			this.vm.businessUserWorker.insuranceWallets
		);
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']);
		
		this.vm.initialized = true;
	}
	
	filterOutActivePolicies(employerActivePolicies, employeeInsuranceWallets) {
		var result: Array<any> = [];
		if (employerActivePolicies && employerActivePolicies.length > 0) {
			MAIN: for (var i = 0; i < employerActivePolicies.length; i++) {
				if (employeeInsuranceWallets && employeeInsuranceWallets.length > 0) {
					for (var j = 0; j < employeeInsuranceWallets.length; j++) {
						if (employerActivePolicies[i].id == employeeInsuranceWallets[j].policy.id) {
							continue MAIN;
						}
					}
				}
				result.push(employerActivePolicies[i]);
			}
		}
		
		return result;
	}
	
	getName() {
		return this.vm.businessUserWorker ? this.vm.businessUserWorker.firstName + ' ' + this.vm.businessUserWorker.lastName : '';
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing || !this.vm.initialized || !this.vm.selectedPolicy) return;
		this.vm.processing = true;
		
		var extraData: any = {};
		extraData.invitation = this.vm.extraData.invitation;
		extraData.policy = this.vm.selectedPolicy;
		extraData.activationDate = this.vm.extraData.activationDate
			? moment(this.vm.extraData.activationDate).utcOffset(0, true).toDate()
			: new Date();
		extraData.terminationDate = this.vm.extraData.terminationDate
			? moment(this.vm.extraData.terminationDate).utcOffset(0, true).toDate()
			: undefined;
		
		this.restService.saveBusinessClientUserUpdateInvitationExtra(extraData)
			.then((response) => {
				this.vm.businessUserWorker.processing = false;
				this.dialogRef.close(response);
				var parentEl: any = document.getElementById('employee-action-element-' + this.vm.businessUserWorker.id);
				this.toast.showWithTranslationInParent('Toast.Worker.InsuranceUpdateSent', parentEl);
			})
			.catch((error) => {
				console.log(error);
				this.vm.processing = false;
				var parentEl: any = document.getElementById('modal-' + this.vm.uid);
				this.toast.showWithTranslationInParent('Toast.Worker.InsuranceUpdateFailed', parentEl);
			});
	}
	
	getExistingInsurancePolicies() {
		var policies: any = "";
		for (var i = 0; i < this.vm.businessUserWorker.insuranceWallets.length; i++) {
			var wallet: any = this.vm.businessUserWorker.insuranceWallets[i];
			policies += ((policies.length > 0 ? ", " : "") + wallet.policy.policyNumber);
		}
		
		return this.angularFilterHelperService.translate('Employees.Placeholder.ExistingInsurancePolicies')
			+ ": "
			+ policies;
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}